/* Sample box drawer: scent list loading.

   Progressive on purpose. Waiting on four collections before painting anything
   left the drawer blank for seconds. Now the FIRST collection resolves and
   renders immediately; the rest merge in behind it via onMore, so the list
   grows rather than making people wait for the slowest request.

   Primary source is still the hidden JSON page, which carries mood and family
   and arrives in one request. */
window.croBoxData = (function () {
  function clean(l) {
    return (l || []).filter(function (s) { return s && s.h && s.t && String(s.t).trim(); });
  }

  function fromPage(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (l) {
        var out = clean(l);
        if (!out.length) throw new Error('empty');
        return { list: out, rich: true };
      });
  }

  function grab(h) {
    return fetch('/collections/' + h.trim() + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return (d.products || []).filter(function (p) { return p.title; }).map(function (p) {
          var img = p.images && p.images[0];
          return {
            h: p.handle, t: p.title, m: '', f: [],
            i: img ? (typeof img === 'string' ? img : img.src) : ''
          };
        });
      })
      .catch(function () { return []; });
  }

  function fromCollections(handles, onMore) {
    var seen = {};
    function merge(into, add) {
      add.forEach(function (s) {
        if (seen[s.h]) return;
        seen[s.h] = 1;
        into.push(s);
      });
      return into;
    }

    return grab(handles[0]).then(function (first) {
      var list = merge([], clean(first));
      if (!list.length && handles.length === 1) throw new Error('empty');

      var rest = handles.slice(1);
      if (rest.length && typeof onMore === 'function') {
        Promise.all(rest.map(grab)).then(function (sets) {
          sets.forEach(function (s) { merge(list, clean(s)); });
          onMore(list);
        });
      }
      return { list: list, rich: false };
    });
  }

  return function (cfg, onMore) {
    var handles = (cfg.collections || 'aroma-oil').split(',');
    return fromPage(cfg.data).catch(function () {
      return fromCollections(handles, onMore);
    });
  };
})();
